import React from 'react';
import { SiteContext } from 'src/context/site-context';
import ExpandIcon from 'src/components/icons/expand';

type NavTabProps = {
  isCollapsed: boolean;
  toggleCollapsed: () => void;
  displayText: string;
  shouldHighlight: boolean;
};

const NavTab: React.FC<NavTabProps> = ({
  isCollapsed,
  toggleCollapsed,
  displayText,
  shouldHighlight,
}) => {
  const { styling, isDL } = React.useContext(SiteContext);
  const oldActiveState = shouldHighlight ? styling.fonts.bold : styling.fonts.regular;
  const newActiveState = styling.fonts.regular;

  const wrapperStyles = isDL
    ? {
        'borderBottom': '1px solid',
        'borderBottomColor': shouldHighlight ? styling.colors.capeCod : 'transparent',
        'lineHeight': '145%',
        '&:hover': {
          svg: { fill: styling.colors.camelot },
          color: styling.colors.camelot,
          borderBottomColor: styling.colors.camelot,
        },
      }
    : {};

  return (
    <div
      css={{
        display: 'flex',
        cursor: 'pointer',
        ...wrapperStyles,
      }}
      onClick={toggleCollapsed}
    >
      <div
        css={[styling.common.headerStyle, isDL ? newActiveState : oldActiveState]}
        data-gtmid="nav-tab-club-facilities"
      >
        {displayText}
      </div>
      <div css={isDL ? { display: 'flex', alignItems: 'center' } : {}}>
        <div
          css={{
            width: '1rem',
            height: '1rem',
            fill: isDL ? styling.colors.capeCod : styling.colors.headerNavigationText,
          }}
          data-gtmid="nav-tab-facilities-dropdown"
        >
          <ExpandIcon
            fill={isDL ? styling.colors.capeCod : styling.colors.headerNavigationText}
            isExpanded={!isCollapsed}
          />
        </div>
      </div>
    </div>
  );
};

export { NavTab };
